import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/auth';
import 'firebase/compat/app-check';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};


if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.database();
const auth = firebase.auth();

// if (process.env.NODE_ENV === 'development') {
//     db.useEmulator("localhost", 9000);
//     auth.useEmulator("http://localhost:9099");
// }

let appCheck = null;
if (typeof window !== 'undefined') {
    const appCheckKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    if (appCheckKey) {
        if (process.env.NODE_ENV === 'development') {
            window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        }

        try {
            appCheck = firebase.appCheck();
            appCheck.activate(
                new firebase.appCheck.ReCaptchaV3Provider(appCheckKey),
                true 
            );
        } catch (error) {
            console.warn('App Check initialization failed:', error);
            appCheck = null;
        }
    }
}

export { firebase, db, auth, appCheck };
